export default function CourseItemSkeleton() {
  return (
    <div className="flex flex-col rounded-xl shadow">
      {/* Image Skeleton */}
      <div className="h-52 rounded-t-lg overflow-hidden bg-gray-200 animate-pulse" />

      <div className="p-4 pb-0">
        <div>
          {/* Title Skeleton */}
          <div className="h-6 bg-gray-200 rounded animate-pulse mb-2 w-3/4" />

          {/* Category Skeleton */}
          <div className="h-4 bg-gray-200 rounded animate-pulse mb-2 w-1/2" />

          {/* Description Skeleton */}
          <div className="space-y-2">
            <div className="h-4 bg-gray-200 rounded animate-pulse w-full" />
            <div className="h-4 bg-gray-200 rounded animate-pulse w-5/6" />
          </div>
        </div>

        {/* Icons Skeleton */}
        <div className="flex gap-2 mt-2.5">
          <div className="h-8 bg-gray-200 rounded-md animate-pulse w-24" />
          <div className="h-8 bg-gray-200 rounded-md animate-pulse w-24" />
        </div>
      </div>

      {/* Footer Skeleton */}
      <div className="flex justify-between items-center p-4 pt-5 mt-auto gap-6">
        <div className="h-9 bg-gray-200 rounded animate-pulse w-24" />
        <div className="h-10 bg-gray-200 rounded-full animate-pulse w-32" />
      </div>
    </div>
  );
}
